import { DashboardComponentPair } from '../../../../models/dashboard';
import { AveragePickTimeDashboardComponent } from './average-pick-time-dashboard.component';
import { AveragePickTimeDashboardFormComponent } from './average-pick-time-dashboard-form.component';

export const ComponentPair: DashboardComponentPair = {
  view: AveragePickTimeDashboardComponent,
  form: AveragePickTimeDashboardFormComponent,
};
